import { Asserts, boolean, object, string } from 'yup';

import { validationLang } from './common';

export const profileGeneralSchema = object({
  firstName: string().trim().min(2).max(64).required(),
  lastName: string().trim().min(2).max(64).required(),
  location: string().trim().required(),
  description: string().trim().min(2).max(150),
  locationShown: boolean(),
});

export type ProfileGeneralSchemaDataType = Asserts<
  typeof profileGeneralSchema
>;

export const profilePrivateSchema = object({
  phone: string().trim().phoneNumber(),
  email: string()
    .trim()
    .email(validationLang.email)
    .max(64)
    .required(),
});

export type ProfilePrivateSchemaDataType = Asserts<
  typeof profilePrivateSchema
>;
